module.exports = require("core-js/modules/es.object.create.js");